import icmywealth from './json/icmywealth.json'
import salutations from './json/salutations.json'
import contactSubjects from './json/contact_subjects.json'
import messageTopics from './json/message_topics.json'
import messageSubjects from './json/message_subjects.json'
import notificationTypes from './json/notification_types.json'
import currencies from './json/currencies.json'
import currenciesLocale from './json/currencies_locale.json'
import transactionTypes from './json/transaction_types.json'
import feeStatuses from './json/fee_statuses.json'
import identificationTypes from './json/identification_types.json'
import monthDays from './json/month_days.json'
import documentTypes from './json/document_types.json'
import beneficialOwner from './json/beneficial_owner.json'
import employmentTypes from './json/employment_types.json'
import residencyStatus from './json/residency_status.json'
import paymentTypes from './json/payment_types.json'
import maturityTypes from './json/maturity_types.json'
import orderTypes from './json/order_types.json'
import paymentServices from './json/payment_services.json'
import plans from './json/plans.json'
import bankAccountTypes from './json/bank_account_types.json'

export default {
    windowSize: {
        width: window.innerWidth,
        height: window.innerHeight
    },
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    user: (typeof localStorage.user !== 'undefined') ? JSON.parse(localStorage.user) : {},
    token: (typeof localStorage.user !== 'undefined') ? localStorage.getItem('token') : null,
    showIdUpdateModal: JSON.parse(localStorage.getItem('showIdUpdateModal')),
    showAnnouncement: true,
    hasDirectDebit: false,
    activeAccount: JSON.parse(localStorage.getItem('activeAccount')),
    customer: {},
    momoAccount: {},
    momoAccounts: [],
    inboxLoad: 1,
    icmywealth,
    salutations,
    contactSubjects,
    messageTopics,
    messageSubjects,
    notificationTypes,
    currencies,
    currenciesLocale,
    transactionTypes,
    feeStatuses,
    identificationTypes,
    monthDays,
    documentTypes,
    beneficialOwner,
    employmentTypes,
    paymentTypes,
    maturityTypes,
    residencyStatus,
    orderTypes,
    paymentServices,
    plans,
    bankAccountTypes,
}
